import React, { useState } from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import styles from '../styles/MultiSelect.module.css';

interface MultiSelectProps<T> {
  items: { label: string; value: T }[];
  onChange: (selected: string[]) => void;
  width?: string;
}

function MultiSelect<T>(props: MultiSelectProps<T>) {
  const [selected, setSelected] = useState<string[]>([]);

  const handleChangeMultiple = (event: SelectChangeEvent<string[]>) => {
    event.preventDefault();
    const selected = event.target.value as string[];
    setSelected(selected);
    props.onChange(selected);
  };

  return (
    <FormControl
      sx={{ minWidth: 120, width: props.width || 'auto' }}
      variant="outlined"
      margin="dense"
      size="small"
    >
      <InputLabel id="mutiple-chip-label">Filter by</InputLabel>
      <Select
        labelId="mutiple-chip-label"
        label="Filter by"
        id="mutiple-chip"
        multiple
        MenuProps={{
          variant: 'menu',
          autoFocus: false,
          disableAutoFocusItem: true,
          disableEnforceFocus: true,
          disableAutoFocus: true
        }}
        value={selected}
        onChange={handleChangeMultiple}
        renderValue={(selected) => (
          <div className={styles.chips}>
            {(selected as string[]).map((value) => (
              <Chip
                key={value}
                label={value}
                className={styles.chip}
                size="small"
              />
            ))}
          </div>
        )}
      >
        {props.items.map((item) => {
          const value = item.value as unknown as string;
          return (
            <MenuItem key={value} value={value}>
              <Checkbox checked={selected.includes(value)} />
              <ListItemText primary={item.label} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default MultiSelect;
